// plugins/matomo.client.js
export default defineNuxtPlugin(() => {
  // Matomo Tag Manager Snippet
  const _mtm = window._mtm = window._mtm || [];
  _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
  const d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
  g.async=true;
  g.src='https://analytics.ws-ds.io/js/container_9CyjjHBX.js'; // Ersetze die URL und Container-ID
  s.parentNode.insertBefore(g,s);

  // Stelle sicher, dass _mtm global zugänglich ist
  window._mtm = _mtm;
});